module.exports = __webpack_public_path__ + "static/img/SPLS.842166f.png";


//////////////////
// WEBPACK FOOTER
// ./static/seriesPic/SPLS.png
// module id = fBV6
// module chunks = 1